<template>
  <div class="app-main-inner">
    <el-dialog
      no="dialog"
      :visible="visible"
      :title="$t('CargoMsg.Cargo_SelectSob')"
      width="630px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      top="5vh"
      custom-class="account-set-popup"
      @open="showDialog"
    >
      <el-form :inline="true" label-width="60px" label-position="left" style="margin-top: 4px;">
        <div class="app-main-inner-row" style="padding: 0;">
          <el-form-item v-if="mode==='tenant'" :label="$t('CargoMsg.Cargo_BranchCMP')" class="el-form-item-w250">
            <el-select v-model="currentOfficeId" no="currentOfficeId" :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')" filterable @change="officeChangeHandler">
              <el-option
                v-for="office in currentOfficeList"
                :key="office.officeId"
                :label="isZh?office.chineseName:office.englishName"
                :value="office.officeId"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button no="Refresh" type="primary" style="width: 65px;" @click="refreshHandler">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
          </el-form-item>
        </div>
        <div class="app-main-inner-row row-grid" style="min-height: 320px;padding: 0;">
          <cargo-ag-grid
            no="grid"
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :auto-fit-content="false"
            :style="{width:'610px',height:'321px'}"
          />
        </div>
        <div v-if="mode==='tenant' && isWT" class="app-main-inner-row" style="padding: 0px;margin-top: 5px;margin-bottom: -11px;justify-content: flex-start;">
          <el-form-item :label="$t('CargoMsg.Cargo_InitialPeriod')">
            <span style="color: red">*</span>
            <span style="margin-right: 10px">{{ $t('CargoMsg.Cargo_PeriodRange') }}</span>
            <el-date-picker
              v-model="dfBeginDate"
              no="dfBeginDate"
              type="date"
              style="width:130px;"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :editable="false"
              @change="dateChangeHandler"
            /></el-form-item>
          <el-form-item label-width="0">
            <el-date-picker
              v-model="dfEndDate"
              no="dfEndDate"
              type="date"
              style="width:130px;"
              clearable
              value-format="yyyy-MM-dd"
              :disabled="true"
            /></el-form-item>
          <el-form-item label-width="0px" style="position: absolute; right: 0; padding-right: 10px;">
            <el-input v-model="yearTxt" no="yearTxt" style="width: 60px;" :disabled="true" />
            <span style="font-size: 12px;"> {{ $t('CargoMsg.Cargo_Year') }} </span>
            <el-input v-model="monthTxt" no="monthTxt" style="width: 60px;" :disabled="true" />
            <span style="font-size: 12px;"> {{ $t('CargoMsg.Cargo_Period') }} </span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" style="height: 25px;">
        <span v-if="mode==='tenant'" style="position: absolute; left: 0; padding-left: 10px;">
          <el-form :inline="true" label-width="60px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_SobName')" class="el-form-item-w200">
              <el-input v-model="txtAccountSetName" no="txtAccountSetName" />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_SobCode')" class="el-form-item-w200">
              <el-input v-model="txtCode" no="txtCode" />
            </el-form-item>
          </el-form>
        </span>
        <span style="position: absolute; right: 0; padding-right: 10px;">
          <el-button v-if="mode==='office'" no="SetToCurrentSob" type="primary" @click="onOK">{{ $t('CargoMsg.Cargo_SetToCurrentSob') }}</el-button>
          <el-button v-if="mode==='tenant'" no="Select" type="primary" style="width: 65px;margin-left: 5px;" @click="onOK">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
          <el-button no="Cancel" style="width: 65px;margin-left: 5px;" @click="onCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from '@/utils/auth'
import { getLoading } from '@/utils/utilBaseElement'
import { query } from '@/api/financeManage/accountSet'
import moment from 'moment'
import * as fiscalPeriodApi from '@/api/financeManage/fiscalPeriod'

export default {
  name: 'AccountSetPopup',
  props: {
    visible: { type: Boolean, required: true },
    mode: { type: String, required: true, default: 'office' }, // office、tenant
    checkFiscalPeriod: { type: Boolean, default: false },
    loadFiscalPeriodInfoFlag: { type: Boolean, default: false }, // 结账信息
    loadAccountingDocumentTypeFlag: { type: Boolean, default: true }, // 凭证类型
    loadAccountTitleFlag: { type: Boolean, default: true }, // 科目
    loadMappingDepartmentsFlag: { type: Boolean, default: true }, // 部门的编码映射
    loadMappingStaffsFlag: { type: Boolean, default: true }, // 职员的编码映射
    loadAccountingDocumentsRuleFlag: { type: Boolean, default: true }, // 凭证分组规则
    loadCurrentRatesFlag: { type: Boolean, default: false }, // 财务汇率
    loadUsedCurrencyFlag: { type: Boolean, default: false }, // 使用币种
    sortFiscalPeriodDesc: { type: Boolean, default: false }, // 倒序排列
    loadYearQuarter: { type: Boolean, default: false }, // 年/季度
    loadUsaReportFlag: { type: Boolean, default: false } // 美国财报
  },
  data() {
    return {
      accountSet: null,
      currentOfficeId: null, // 分公司
      txtAccountSetName: '', // 账套名称
      txtCode: '', // 账套代码
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onOK
      },
      gridParams: {},
      columnDefs: [
        { headerName: this.$t('CargoMsg.Cargo_Company'), field: 'branchCode', width: 80 },
        { headerName: this.$t('CargoMsg.Cargo_SobName'), field: 'name', width: 140 },
        { headerName: this.$t('CargoMsg.Cargo_AccountTitleClassificationRule'), field: 'accountTitleGradeRule', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_FinancialSoftware'), field: 'softwareVersionsName', width: 160 },
        { headerName: this.$t('CargoMsg.Cargo_InterfaceScheme'), field: 'interfaceSchemeName', width: 90 }
      ],
      rowData: [],
      dfBeginDate: null, // 期间范围
      dfEndDate: null,
      yearTxt: '',
      monthTxt: '',
      changeFlag: false,
      selectedItem: null // 表格选中项
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    currentOfficeList() {
      return getUserInfo().currentUserOfficeList
    },
    isWT() {
      if (this.accountSet === null) {
        return false
      } else {
        return this.accountSet.softwareVersions === 'WT'
      }
    },
    currentOfficeUuid() {
      return this.$store.getters.currentOfficeUuid
    }
  },
  watch: {
    currentOfficeUuid: {
      immediate: false,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) this.changeFlag = true
      }
    }
  },
  mounted() {
    if (this.mode === 'office') {
      this.loadAccount()
    }
  },
  methods: {
    async loadAccount() {
      console.log('loadAccount')
      let branchId = 0
      if (this.mode === 'office') {
        branchId = this.$store.getters.currentOfficeId
      } else {
        if (this.currentOfficeId === null) {
          await this.$confirm(this.$t('CargoMsg.Cargo_PleaseSelectBranch'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
          })
          return
        }
        branchId = this.currentOfficeId
      }
      //
      this.loading = getLoading()
      query({ branchId: branchId, mode: this.mode }).then(res => {
        this.rowData = res.data.list
      }).finally(() => {
        this.loading.close()
      })
      if (this.gridOptions.api) this.gridOptions.api.clearFocusedCell()
      this.selectedItem = null
    },
    // 刷新
    refreshHandler() {
      this.loadAccount()
    },
    // 设为当前账套/选择
    onOK() {
      const cell = this.gridOptions.api.getFocusedCell()
      // const accountSet = cell ? this.rowData[cell.rowIndex] : null
      const accountSet = cell ? this.selectedItem : null
      if (!accountSet) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (accountSet.softwareVersions === 'WT' && this.checkFiscalPeriod) {
        // accountSet.fiscalPeriod = fiscalPeriodApi.query({ accountingSetKey: accountSet.uuid })
        this.loading = getLoading()
        query({ branchId: this.$store.getters.currentOfficeId, uuid: this.accountSet.uuid, mode: this.mode }).then(res => {
          this.loadFiscalPeriodResultHandler(res.data.list[0])
          this.onCancel()
        }).finally(() => {
          this.loading.close()
        })
      } else {
        if (this.mode === 'tenant' && this.accountSet.softwareVersions === 'WT') {
          if (!this.validateWTAccountSet()) {
            return
          }
          this.wtAccountingSelect()
          return
        }
        this.loading = getLoading()
        query({ branchId: this.$store.getters.currentOfficeId, uuid: this.accountSet.uuid, mode: this.mode,
          loadFiscalPeriodInfoFlag: this.loadFiscalPeriodInfoFlag,
          loadAccountingDocumentTypeFlag: this.loadAccountingDocumentTypeFlag,
          loadAccountTitleFlag: this.loadAccountTitleFlag,
          loadMappingDepartmentsFlag: this.loadMappingDepartmentsFlag,
          loadMappingStaffsFlag: this.loadMappingStaffsFlag,
          loadAccountingDocumentsRuleFlag: this.loadAccountingDocumentsRuleFlag,
          loadCurrentRatesFlag: this.loadCurrentRatesFlag,
          loadUsaReportFlag: this.loadUsaReportFlag,
          loadUsedCurrencyFlag: this.loadUsedCurrencyFlag }).then(res => {
          if (res.data.list.length > 0) this.accountSet = res.data.list[0] // 加载附加信息
          if (this.sortFiscalPeriodDesc) this.sortFiscalPeriodDescHandler(this.accountSet.fiscalPeriod)
          if (this.loadYearQuarter) this.loadYearQuarterHandler(this.accountSet)
          this.$emit('select', this.accountSet)
          this.onCancel()
        }).finally(() => {
          this.loading.close()
        })
      }
    },
    // 取消
    onCancel() {
      this.$emit('cancel', '')
    },
    onRowClicked(event) {
      console.log('onRowClicked', event.data)
      this.accountSet = event.data
      this.selectedItem = event.data

      if (this.accountSet !== null) {
        this.txtAccountSetName = 'Copy of ' + this.accountSet.name
        this.txtCode = 'Copy of ' + this.accountSet.code
      } else {
        this.txtAccountSetName = ''
        this.txtCode = ''
      }
    },
    officeChangeHandler(value) {
      console.log('officeChangeHandler:', value)
      this.currentOfficeId = value
      this.loadAccount()
    },
    dateChangeHandler(value) {
      console.log('dateChangeHandler:', value)
      this.dfBeginDate = moment(value).startOf('month').format('YYYY-MM-DD')
      this.dfEndDate = moment(value).endOf('month').format('YYYY-MM-DD')
      this.yearTxt = String(moment(value).year())
      this.monthTxt = String(moment(value).month() + 1)
    },
    loadFiscalPeriodResultHandler(accountSet) {
      if (accountSet) {
        const fiscalPeriods = accountSet.fiscalPeriod
        let hasPeriod = false
        if (fiscalPeriods && fiscalPeriods.length > 0) {
          for (const fiscalPeriod of fiscalPeriods) {
            if (fiscalPeriod.closing === false) {
              hasPeriod = true
              break
            }
          }
        }
        if (hasPeriod) {
          if (this.currentState === 'tenant' && accountSet.softwareVersions === 'WT') {
            if (!this.validateWTAccountSet()) return
            this.wtAccountingSelect()
            return
          }
          this.accountSet = accountSet
          this.$emit('select', accountSet)
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_NFPAFTS'))
        }
      }
    },
    validateWTAccountSet() {
      if (!this.dfBeginDate || !this.dfEndDate) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseSelectPeriodRange'))
        return false
      }
      if (this.txtAccountSetName.trim().length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseEnterSobName'))
        return false
      }

      if (this.txtCode.trim().length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PleaseEnterSobCode'))
        return false
      }

      if (this.yearTxt.trim().length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_InitialPeriodCanTBeEmpty'))
        return false
      }
      if (this.monthTxt.trim().length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_InitialPeriodCannotBeEmpty'))
        return false
      }
      return true
    },
    wtAccountingSelect() {
      const fiscalPeriod = {}
      fiscalPeriod.beginDate = this.dfBeginDate
      fiscalPeriod.endDate = this.dfEndDate
      fiscalPeriod.year = Number(this.yearTxt)
      fiscalPeriod.month = Number(this.monthTxt)
      fiscalPeriod.initialPeriod = true
      this.$emit('accountingSelect', fiscalPeriod)
    },
    // 倒序排列
    sortFiscalPeriodDescHandler(list) {
      if (list) list.reverse()
    },
    showDialog() {
      if (this.changeFlag) {
        this.changeFlag = false
        this.refreshHandler()
      }
    },
    loadYearQuarterHandler(accountSet) {
      const YearList = []
      const QuarterList = []
      if (accountSet.fiscalPeriod) {
        for (const fiscalPeriod of accountSet.fiscalPeriod) {
          if (fiscalPeriod.month === 1) {
            // 年报=公历1月1日-12月31
            YearList.push(fiscalPeriod)
            // 第1季度=1-3月份，以此类推
            QuarterList.push(fiscalPeriod)
          } else if (fiscalPeriod.month === 4 || fiscalPeriod.month === 7 || fiscalPeriod.month === 10) {
            QuarterList.push(fiscalPeriod)
          }
        }
      }
      accountSet.Years = YearList
      accountSet.Quarters = QuarterList
    }
  }
}
</script>

<style lang="scss">
.account-set-popup {
  .el-dialog__body {
    padding: 10px !important;
  }
  .el-form-item-w200 {
    width: 200px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 140px;
      .el-input__inner {
        padding: 0px 6px !important;
      }
    }
  }
  .el-form-item-w250 {
    width: 250px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 190px;
      .el-input__inner {
        padding: 0px 6px !important;
      }
    }
  }
}
</style>
